module.exports = __webpack_public_path__ + "img/swiper1.01278567.png";